<template>
  <div class="ibox float-e-margins no-margin-b">
    <div class="row wrapper border-bottom white-bg mobile-p-left-12" style="padding-top: 22px !important;">
      <div class="col-xs-8 col-md-5 header_title">
        <ol v-if="itemType==='booking'" class="breadcrumb" style="font-size:14px;" >
          <li class="breadcrumb-item" style="padding-right: 9px">
              <a v-if="bookingStatus==3" href="/estimates">Quotes</a>
              <a v-else href="/booking">Bookings</a>
          </li>
          <svg style="margin-bottom: -2px" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.406367 10.7424L1.4447 11.7749L7.21387 5.9999L1.43887 0.224903L0.406367 1.2574L5.14887 5.9999L0.406367 10.7424Z" fill="#2E4051"/> </svg>
          <li class="breadcrumb-item active" style="padding-left: 9px; font-weight: 400">
            Manage {{ bookingStatus==3 ?  'quote':'booking' }}
          </li>
        </ol>

        <ol v-if="itemType==='inquiry'" class="breadcrumb" style="font-size:14px;" >
          <li class="breadcrumb-item" style="padding-right: 9px">
              <a href="/inquiry">Inquiries</a>
          </li>
          <svg style="margin-bottom: -2px" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.406367 10.7424L1.4447 11.7749L7.21387 5.9999L1.43887 0.224903L0.406367 1.2574L5.14887 5.9999L0.406367 10.7424Z" fill="#2E4051"/> </svg>
          <li class="breadcrumb-item active" style="padding-left: 9px; font-weight: 400">
            Inquiry Details
          </li>
        </ol>
        <div>

          <strong v-if="(itemType==='booking' && bookingEstimate && !bookingEstimateIsDeleted && bookingStatus==3) && bookingEstimate.id " class="booking_title">{{ bookingEstimateNumber }}</strong>
          <strong v-else-if="itemType==='booking'" class="booking_title">{{ bookingNumber }}</strong>
          <strong v-if="itemType==='inquiry'" class="booking_title">{{ inquiryNumber }}</strong>

          <!-- actions dropdown list-->
          <nav v-if="loggedUserRole!=='customer'" class="three-dots-container-position">
            <div class="action-container">
              <view-item-dropdown-action


                  :item-booking='itemBooking'
                  :item-estimate='itemEstimate'
                  :item-invoice='itemInvoice'
                  :item-object="itemObject"
                  :booking-invoice='bookingInvoice'
                  :logged-user='loggedUser'
                  :contractor-role-id='contractorRoleId'
                  :estimate-data='estimateData'
                  :allow-fieldworker-add-booking='allowFieldworkerAddBooking'
                  :status='status'
                  :item-string='itemString'
                  :is-repeated='isRepeated'
                  :parent-num='parentNum'
                  :is-accepted='isAccepted'
                  :show-billing-info-condition='showBillingInfoCondition'
                  :has-multiple-open-cycles='hasMultipleOpenCycles'
                  :parent-id='parentId'
                  :estimate-params='estimateParams'
                  :shown-horizontal-line='shownHorizontalLine'
                  :nearest-booking-params='nearestBookingParams'
                  :find-availability-params='findAvailabilityParams'
                  :all-credentials-array='allCredentialsArray'
                  :can-delete='canDelete'
                  :logged-user-role='loggedUserRole'
                  :view-page="true"
                  :item-type='itemType'
              >
              </view-item-dropdown-action>
            </div>

            <div class="" style="margin-right:3px;" v-if="loggedUserRole === customerRole">
              <div class="btn-group">
                <a class="btn btn-primary" :href="seeAllBookings()"><i class="fa fa-play" aria-hidden="true"></i> See All Booking</a>
              </div>

              <div v-if="company" class="btn-group">
                <a class="btn btn-primary" @click="visitHomePage()" ><i class="fa fa-home" aria-hidden="true"></i> Visit Home Page</a>
              </div>
            </div>
          </nav>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ViewItemDropdownAction from "../../../Booking/components/booking/viewItemDropdownAction.vue";

export default {
    name: "Breadcrumb",
    components: {
      ViewItemDropdownAction,
    },
    props: {

itemBooking : null,
itemEstimate : null,
itemInvoice : null,
    itemObject: {},
    bookingInvoice: null,
    loggedUser: null,
    contractorRoleId: null,
    hasRecurring: null,
    estimateData: null,
    allowFieldworkerAddBooking: null,
    status: null,
    itemString: null,
    isRepeated: null,
    parentNum: null,
    isAccepted: null,
    showBillingInfoCondition: null,
    hasMultipleOpenCycles: null,
    parentId: null,
    estimateParams: null,
    shownHorizontalLine: null,
    nearestBookingParams: null,
    findAvailabilityParams: null,
    allCredentialsArray: null,
    canDelete: null,
    loggedUserRole: null,
    itemType: null,
    bookingStatus: null,
    inquiryNumber: null,
    bookingNumber: null,
    bookingEstimate: null,
    bookingEstimateIsDeleted: null,
    bookingEstimateNumber: null,
    company: null,
    customerRole: null,
  },
    data(){
      return {
      };
    },
    methods:{
        seeAllBookings(){
          return `/booking?fltr[customer_id]=${this.itemObject.customer_id}`;
        },
        visitHomePage(){
          let url = `http://${this.company.company_website}`;
          window.open(url, '_blank');
        }
    },
}
</script>

<style scoped>
.breadcrumb-item{
  line-height: 20px;
  font-size: 14px;
  display: inline-block;
  color: #2E4051;
}
.breadcrumb>li+li:before {
  color: #2E4051;
}
.booking_title{
  font-size: 32px;
}
.header_title{
  color: #2E4051;
}
.buttons_all_div{
  margin-top: 2%;
}
.three-dots-container-position {
  display: inline-block;
  position: absolute;
  bottom: 0px;
  margin-left: 10px;
}
@media screen and (max-width: 991px) {
  .three-dots-container-position{
    bottom: 0px;
  }
  .three-dots-container-position .dropdown-menu{
    right: -35px;
  }
  .mobile-p-left-12 {
    padding-left: 12px !important;
  }
}
</style>